angular.module('directives.dashboard').directive('wgtInfoQuickSaleFact', ['DashboardApiService',
        function (DashboardApiService) {
            return {
                templateUrl: 'directives/dashboard/widgets/wgtInfoQuickSaleFact/wgtInfoQuickSaleFact.tpl.html',
                link: function ($scope) {
                    $scope.isLoaded = false;
                    $scope.hasError = false;
                    $scope.loadWidget = function () {
                        DashboardApiService.getWidgetData($scope.item.name, $scope.item.setting)
                            .then(function (response) {
                                $scope.widgetData = response.data;
                                $scope.isLoaded = true;
                            }, function (response) {
                                $scope.hasError = true;
                            });
                    };
                    $scope.loadWidget();
                }
            };
        }]
);
